export function loadConfig(env = ''): Promise<ConfigModule> {
  return import(/* webpackChunkName: "[request]" */
    `./config/environment-${env}`
  );
}
